import { NOTIFICATION_TYPE_ENUM } from "interfaces";
import { useNotificationContext } from "providers";
import { useState } from "react";

import { approveContract } from "services";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { parseErrorMessage } from "utils";

export const ApproveContractButton = () => {
  const [loading, setLoading] = useState(false);
  const { openNotification } = useNotificationContext();

  const { contractCard } = useStores();

  const approveContractHandler = async () => {
    setLoading(true);
    await approveContract({ id: contractCard.card.id })
      .then(() => {
        openNotification({
          message: "Договор успешно утвержден",
          type: NOTIFICATION_TYPE_ENUM.SUCCESS,
        });
        setTimeout(() => {
          setLoading(false);
          contractCard.fetchCardById(contractCard.card.id);
        }, 1500);
      })
      .catch((e) => {
        setLoading(false);
        openNotification({
          description: parseErrorMessage(e),
          type: NOTIFICATION_TYPE_ENUM.ERROR,
        });
      });
  };
  return (
    <CustomButton tooltip={"Утвердить черновик договора"} onClick={approveContractHandler} loading={loading}>
      Утвердить
    </CustomButton>
  );
};
